import { flow, getSnapshot, types } from 'mobx-state-tree';
import { Files } from 'http-requests';
import { RequestStateModel } from '../general-models';

export const FileModel = types
  .model('File', {
    id: types.optional(types.string, ''),
    shared_id: types.optional(types.string, ''),
    expiring_at: types.optional(types.maybeNull(types.string), null),
    importance: types.optional(
      types.enumeration(['low', 'high'] as const),
      'low'
    ),
    size_bytes: types.optional(types.number, 0),
    filename: types.optional(types.string, ''),
    uploaded_at: types.optional(types.string, ''),
    day_usages: types.optional(types.number, 0),
    week_usages: types.optional(types.number, 0),
    month_usages: types.optional(types.number, 0),
    year_usages: types.optional(types.number, 0),
    last_used_at: types.optional(types.maybeNull(types.string), null),
  })
  .volatile(() => ({
    downloadStatus: RequestStateModel.create({}),
    getInfoStatus: RequestStateModel.create({}),
  }))
  .views((self) => ({
    get snapshot() {
      return getSnapshot(self);
    },
  }))
  .actions((self) => ({
    updateSharedId(sharedId: string) {
      self.shared_id = sharedId;
    },
    getInfo: flow(function* () {
      try {
        self.getInfoStatus.loadingStates();
        const response = yield Files.GetFileInfo(self.shared_id);
        self.getInfoStatus.successStates();
        self.filename = response.filename;
        self.uploaded_at = response.uploaded_at;

        return response;
      } catch (error) {
        self.getInfoStatus.errorStates();
        console.error(error);
      } finally {
        self.getInfoStatus.finallyStates();
      }
    }),
    download: flow(function* () {
      try {
        self.downloadStatus.loadingStates();
        const response = yield Files.GetFileFromFilesMS(self.shared_id);
        const blob = yield response.blob();
        self.downloadStatus.successStates();

        return blob;
      } catch (error) {
        self.downloadStatus.errorStates();
        console.error(error);

        return Promise.reject(error);
      } finally {
        self.downloadStatus.finallyStates();
      }
    }),
  }));
